import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface LanguageState {
  language: string
}

// Idiomas con diccionario en `src/language`. La lista se usa como lista blanca al
// leer de `localStorage`: `useLang()` hace `require(\`./${language}\`)`, así que un
// valor manipulado a mano en el navegador rompería el arranque de la app.
export const IDIOMAS = ['CA', 'ES']

const LANGUAGE_KEY = 'ebcn_language'

const leerIdiomaGuardado = () => {

  const guardado = localStorage.getItem(LANGUAGE_KEY)

  return IDIOMAS.includes(guardado || '') ? (guardado as string) : 'CA'
}

const initialState: LanguageState = {
  // Idioma por defecto 'CA' si no hay nada guardado todavía.
  language: leerIdiomaGuardado(),
}

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    changeLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
      localStorage.setItem(LANGUAGE_KEY, action.payload)
    }
  },
})

// Action creators are generated for each case reducer function
export const { changeLanguage } = languageSlice.actions

// export default counterSlice.reducer